<template>
  <b-modal size="lg" ref="modal" @close="close" centered no-close-on-backdrop>
    <template #modal-header="{ close }">
      <div class="d-flex justify-content-between align-items-center w-100">
        <div></div>
        <h5 class="text-centerfont-weight-bolder m-0">Company Details</h5>
        <b-button
          size="sm"
          variant="none"
          class="btn-icon btn-circle btn-hover-dark"
          title="Close"
          @click="close"
          v-b-tooltip.hover
          >

          <i class="material-icons icon-xl">close</i>
        </b-button>
      </div>
    </template>

    <template #default v-if="fetching">
      <div class="d-flex align-items-center justify-content-center">
        Loading...
      </div>
    </template>
    <template #default v-else>
      <b-row class="d-flex justify-content-center mx-2">
        <div class="alert text-center font-weight-bolder" :class="variants" v-if="error && error.length">
          {{ error }}
        </div>
      </b-row>
      <b-row class="d-flex justify-content-center mx-2">
        <b-col class="col-6">
          <div class="row mb-3 d-flex align-items-center">
            <div class="col-5 font-weight-bolder text-right">Name</div>
            <div class="col-7" style="overflow-wrap: break-word;">
              {{ company.name }}
            </div>
          </div>

          <div class="row mb-3 d-flex align-items-center">
            <div class="col-5 font-weight-bolder text-right">Country</div>
            <div class="col-7">{{ company.country || "-" }}</div>
          </div>

          <div class="row mb-3 d-flex align-items-center">
            <div class="col-5 font-weight-bolder text-right">Currency</div>
            <div class="col-7">{{ company.base_currency || "-" }}</div>
          </div>

          <div class="row mb-3 d-flex align-items-center">
            <div class="col-5 font-weight-bolder text-right">Admin Name</div>
            <div class="col-7" style="overflow-wrap: break-word;">{{ (company.admin_user && company.admin_user.first_name) || "-" }}</div>
          </div>


          <div class="row mb-3 d-flex align-items-center">
            <div class="col-5 font-weight-bolder text-right">Admin Email</div>
            <div class="col-7" style="overflow-wrap: break-word;">{{ (company.admin_user && company.admin_user.email) || "-" }}</div>
          </div>
          <div v-if="company.is_merchant">
            <div class="row mb-3 d-flex align-items-center">
              <div class="col-5 font-weight-bolder text-right">Invoice Count</div>
              <!-- <div class="col-7">{{ analytics.invoices_analytics.invoices_count || "-" }}</div> -->
            </div>
            <div v-if="company.fixed_charge" class="row mb-3">
              <div class="col-4 font-weight-bolder text-right">Fixed Charge</div>
              <div class="col-8">{{ company.fixed_charge + ' ' + company.base_currency || "-" }}</div>
            </div>

            <div v-if="company.variable_charge" class="row mb-3">
              <div class="col-4 font-weight-bolder text-right">Variable Charge</div>
              <div class="col-8">{{ company.variable_charge || "-" }} %</div>
            </div>

            <div v-if="company.billing_period_value" class="row mb-3">
              <div class="col-4 font-weight-bolder text-right">Billing Period Value</div>
              <div class="col-8">{{ company.billing_period_value || "-" }}</div>
            </div>

            <div v-if="company.billing_period_unit" class="row mb-3">
              <div class="col-4 font-weight-bolder text-right">Billing Period Unit</div>
              <div class="col-8">{{ company.billing_period_unit || "-" }}</div>
            </div>
          </div>

            <div class="row mb-3 d-flex align-items-center">
              <div class="col-5 font-weight-bolder text-right">Invoice Volume</div>
              <div class="col-7">
                <!-- AED {{ new Intl.NumberFormat("en-US", { -->
                <!--         style: "decimal", -->
                <!--         roundingIncrement: 5, -->
                <!--         minimumFractionDigits: 2, -->
                <!--         maximumFractionDigits: 2, -->
                <!--       }).format(analytics.invoices_analytics.invoices_sum_AED) || "-"  -->
                <!--     }} -->
              </div>
            </div>
            <div class="row mb-3 d-flex align-items-center">
              <div class="col-5 font-weight-bolder text-right">Status</div>
              <div class="col-7">
                <div class="label label-inline label-light-danger font-weight-bolder py-4" v-if="!company.active">
                  INACTIVE
                </div>
                <div class="label label-inline label-light-success font-weight-bolder py-4" v-else>
                  ACTIVE
                </div>
              </div>
            <div class="row mb-3 d-flex align-items-center">
              <div class="col-5 font-weight-bolder text-right">Invoice Volume</div>
              <div class="col-7">
                AED {{ new Intl.NumberFormat("en-US", {
                        style: "decimal",
                        roundingIncrement: 5,
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(analytics.invoices_analytics.invoices_sum_AED) || "-" 
                    }}
              </div>
            </div>
          </div>
          <div class="row mb-3 d-flex align-items-center">
            <div class="col-5 font-weight-bolder text-right">Status</div>
            <div class="col-4 d-flex">
              <div style="padding-right: 3rem !important;">
                <b-form-checkbox v-model="company.active" @change="toggleActive" switch> </b-form-checkbox>
              </div>
              <div
                class="label label-inline label-light-danger font-weight-bolder py-4"
                v-if="!company.active"
                >
                INACTIVE
              </div>
            </div>
            <div class="row mb-3 d-flex align-items-center">
              <div class="col-5 font-weight-bolder text-right">News Letter</div>
              <div class="col-7" @click="previewNewsLetter()">
                <div class="label label-inline label-dark-secondary font-weight-bolder py-4">
                  Preview
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3 d-flex align-items-center">
            <div class="col-5 font-weight-bolder text-right">News Letter</div>
            <div class="col-7"  @click="previewNewsLetter()">
              <div class="label label-inline label-dark-secondary font-weight-bolder py-4">
                Preview
            </div> 
          </div>
          </div>


        </b-col>
        <b-col class="col-5">
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Merchant</div>
            <b-form-checkbox v-model="company.is_merchant" switch> </b-form-checkbox>
          </div>
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Allow Integrations</div>
            <b-form-checkbox v-model="company.allow_integrations" switch> </b-form-checkbox>
          </div>
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Enable bank payments</div>
            <b-form-checkbox v-model="company.enable_bank_payments" switch> </b-form-checkbox>
          </div>
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Partial pay </div>
            <b-form-checkbox v-model="company.partial_payments" switch> </b-form-checkbox>
          </div>
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Bypass Buyer Signup</div>
            <b-form-checkbox v-model="company.bypass_buyer_signup" switch> </b-form-checkbox>
          </div>
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Allow Account Integrations</div>
            <b-form-checkbox v-model="company.allow_account_integrations" switch> </b-form-checkbox>
          </div>
          <div class="row mb-3">
            <div class="col-9 font-weight-bolder text-left">Send Monthly NewsLetter</div>
            <b-form-checkbox v-model="company.send_monthly_newsletter" switch> </b-form-checkbox>
          </div>
        </b-col>
      </b-row>
    </template>

    <template #modal-footer="{ close }">
      <div class="d-flex justify-content-between mx-auto">
        <b-button class="btn-pill font-weight-bold mr-2" variant="dark" @click="generateBillingInvoice" :disabled="pdfloading">
          <span>Generate Billing Invoice</span>
        </b-button>
                <b-button class="btn-pill font-weight-bold mx-1" variant="dark" :disabled="disabled" @click="close">
          <span>Close</span>
        </b-button>
        <b-button
          class="btn-pill font-weight-bold"
          variant="dark"
          :disabled="disabled"
          @click="()  => {editBusiness();}"
        >

          <span>Save</span>
        </b-button>
      </div>
      <Billing ref="billing-modal"/>
    </template>
  </b-modal>
</template>

<script>
import { formatErrorMessage } from "@/utils/random_utils";
import AnalyticsService from "@/services/analytics.service";
import CompaniesService from "@/services/companies.service";
import EnumeratesService from "@/services/enumerates.service";

import pdfViewer from "@/components/pdfViewer.vue";
import Billing from './billing.vue'

export default {
  name: "Details",
  components: {
    pdfViewer,
    Billing,
    // DateSelector,
  },
  data() {
    return {
      selected_pdf: null,
      pdfloading: false,
      env: process.env.NODE_ENV,
      API_URL: process.env.VUE_APP_API_URL,
      error: null,
      fetching: false,
      company: {},
      pdfName: "",
    };
  },
  methods: {
    async fetch(id) {
      this.fetching = true;

      CompaniesService.get(id)
        .then(async ({ data }) => {
          this.company = data;

          const country_data = await EnumeratesService.countries();

          if (country_data?.data?.length) {
            const rec = country_data.data.find(
              (each) => each.id === data?.country
            );
            if (rec?.name) this.company["country"] = rec?.name;
          }

          const currency_data = await EnumeratesService.currencies();

          if (currency_data?.data?.length) {
            const rec = currency_data.data.find(
              (each) => each.id === data?.base_currency
            );
            if (rec?.name) this.company["base_currency"] = rec?.name;
          }
        })
        .catch(({ message }) => {
          this.error = formatErrorMessage(message);
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    open(business) {
      this.error = null;
      this.fetching = false;
      this.company = business;
      this.$refs["modal"].show();
    },
    generateBillingInvoice() {
      this.$refs["billing-modal"].open(this.company);
    },
    getURL(halfUrl) {
      if (this.env === 'development') {
        return this.API_URL + halfUrl;
      }
      else {
        return halfUrl;
      }
    },
    close(){
      this.$emit('close');
      this.$refs['modal'].hide();
    },
    previewNewsLetter() {
      if (this.company.send_monthly_newsletter == true) {
        this.$emit('preview');
      }
      else {
        this.error = 'No subscription for newsletter';
      }

    },
    toggleActive(event){
      this.company.allow_integrations = this.company.is_merchant ? event : false;
    },
    editBusiness() {
      CompaniesService.patch(this.company.id,
        {
          'is_merchant': this.company.is_merchant,
          'allow_integrations': this.company.allow_integrations,
          'enable_bank_payments': this.company.enable_bank_payments,
          'partial_payments': this.company.partial_payments,
          'bypass_buyer_signup': this.company.bypass_buyer_signup,
          'allow_account_integrations': this.company.allow_account_integrations,
          'send_monthly_newsletter': this.company.send_monthly_newsletter,
          'active': this.company.active,
        }
      )
        .catch((err) => console.log(err));
    },
    closeAttachment() {
      this.selected_pdf = null;
      this.close()
        .then(() => {})
        .catch((err) => {
          console.log(err);
          this.error = formatErrorMessage(err.message);
        });
    },
  },
  computed: {
    disabled() {
      return this.sending;
    },
    variants() {
      return {
        show: this.error,
        "alert-light-danger": this.error,
      };
    },
  },

  watch: {
    company(newval) {
      if (newval.id) {
        this.fetching = true;
        AnalyticsService.get('merchants',{"id": this.company.id})
        .then(({data}) => {
          this.analytics = data.current;
        })
        .catch((err) => {
          console.log(err);
          this.error = formatErrorMessage(message);
        })
        .finally(() => {
          this.fetching = false;
        });
      }
    },
  },
};
</script>
